"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_omit_1 = __importDefault(require("lodash.omit"));
var _kernel_store_types_1 = require("../../types");
var _kernel_container_1 = __importDefault(require("../../../container"));
var PersistenceService = (function () {
    function PersistenceService() {
    }
    PersistenceService.getStateToPersist = function (state) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var extPersist = _kernel_container_1.default.get("__EXT_PERSISTENCE");
        return __assign({ global: {
                turnedOn: (_a = state.global.turnedOn) !== null && _a !== void 0 ? _a : true,
                autoStart: (_b = state.global.autoStart) !== null && _b !== void 0 ? _b : false,
                bindingCode: (_c = state.global.bindingCode) !== null && _c !== void 0 ? _c : null,
                autoPlay: (_d = state.global.autoPlay) !== null && _d !== void 0 ? _d : false,
                kioskMode: (_e = state.global.kioskMode) !== null && _e !== void 0 ? _e : false,
                analyticsEnabled: (_f = state.global.analyticsEnabled) !== null && _f !== void 0 ? _f : true,
                theme: (_g = state.global.theme) !== null && _g !== void 0 ? _g : "auto",
                preloadTracks: (_h = state.global.preloadTracks) !== null && _h !== void 0 ? _h : true,
                additionalFeatures: (_j = state.global.additionalFeatures) !== null && _j !== void 0 ? _j : [],
                stateVersion: (_k = state.global.stateVersion) !== null && _k !== void 0 ? _k : "",
            }, point: __assign(__assign({}, state.point), { metadata: {} }), history: state.history, playbackHistory: { items: state.playbackHistory.items }, mediafiles: Object.values(state.mediafiles).map(function (mediafile) {
                var _a;
                return __assign(__assign({}, (0, lodash_omit_1.default)(mediafile, ["cacheState", "files"])), { files: mediafile.files.map(function (file) { return (0, lodash_omit_1.default)(file, ["cacheState"]); }), rightholder: (_a = mediafile.rightholder) !== null && _a !== void 0 ? _a : 0 });
            }), player: {
                volume: state.player.volume,
                lastRequiredPlayState: state.player.lastRequiredPlayState,
            }, generation: {
                currentSettings: (_l = state.generation) === null || _l === void 0 ? void 0 : _l.currentSettings,
                upcomingSettings: (_m = state.generation) === null || _m === void 0 ? void 0 : _m.upcomingSettings,
                metadata: (0, lodash_omit_1.default)((_p = (_o = state.generation) === null || _o === void 0 ? void 0 : _o.metadata) !== null && _p !== void 0 ? _p : {}, [
                    "areSettingsFetching",
                    "isLastUpdateFetching",
                    "lastLastUpdateFetch",
                    "regenerationRequired",
                    "regenerationInProgress",
                    "generationFetchLocked",
                    "nextRegenerationImmediateSwitch",
                ]),
            }, caching: state.caching, reactions: state.reactions }, extPersist.persist(state));
    };
    PersistenceService.loadPersistedState = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return __awaiter(this, void 0, void 0, function () {
            var logger, persist, extPersist, prevState, _o, persistedMediafiles, totalSize, _p, _q, e_1;
            return __generator(this, function (_r) {
                switch (_r.label) {
                    case 0:
                        logger = _kernel_container_1.default.get("LOGGING").getLogger("@persist");
                        persist = _kernel_container_1.default.get("PERSISTENCE");
                        extPersist = _kernel_container_1.default.get("__EXT_PERSISTENCE");
                        _r.label = 1;
                    case 1:
                        _r.trys.push([1, 7, , 8]);
                        return [4, persist.loadState()];
                    case 2:
                        prevState = _r.sent();
                        if (!prevState) {
                            return [2];
                        }
                        if (!prevState) return [3, 4];
                        return [4, persist.loadMediafiles(prevState)];
                    case 3:
                        _p = _r.sent();
                        return [3, 5];
                    case 4:
                        _p = [];
                        _r.label = 5;
                    case 5:
                        _o = __read.apply(void 0, [_p, 2]), persistedMediafiles = _o[0], totalSize = _o[1];
                        _q = [{ global: __assign(__assign({}, (prevState.global || {})), { bindingCode: (_a = prevState.global.bindingCode) !== null && _a !== void 0 ? _a : undefined, turnedOn: (_b = prevState.global.turnedOn) !== null && _b !== void 0 ? _b : true, isConnected: true, analyticsEnabled: false, totalMediafilesSize: totalSize !== null && totalSize !== void 0 ? totalSize : 0, additionalFeatures: (_c = prevState.global.additionalFeatures) !== null && _c !== void 0 ? _c : [] }), point: __assign(__assign({}, prevState.point), { isEnabled: (_e = (_d = prevState.point) === null || _d === void 0 ? void 0 : _d.isEnabled) !== null && _e !== void 0 ? _e : true }), playlist: {
                                    lastLocalRotationId: 0,
                                    safeSwitchZone: true,
                                }, history: prevState.history, playbackHistory: prevState.playbackHistory
                                    ? {
                                        items: prevState.playbackHistory.items,
                                        metadata: {},
                                    }
                                    : { items: [], metadata: {} }, mediafiles: persistedMediafiles ? Object.fromEntries(persistedMediafiles) : {}, mediafilesMeta: {
                                    mediafileDownloadErrors: {},
                                    mediafileDownloadDelays: {},
                                    mediafileDownloadQueue: [],
                                    currentDownloading: [],
                                    mediafileCleanupQueue: [],
                                    currentCleaningUp: [],
                                }, player: {
                                    volume: (_g = (_f = prevState.player) === null || _f === void 0 ? void 0 : _f.volume) !== null && _g !== void 0 ? _g : 1,
                                    currentPlayState: _kernel_store_types_1.EPlayState.STOP,
                                    requiredPlayState: _kernel_store_types_1.EPlayState.STOP,
                                    lastRequiredPlayState: (_h = prevState.player) === null || _h === void 0 ? void 0 : _h.lastRequiredPlayState,
                                    playerStalled: false,
                                    startPlaybackAttempt: {
                                        time: null,
                                        success: false,
                                        failureReason: null,
                                    },
                                }, notifications: [], generation: {
                                    metadata: (_k = (_j = prevState.generation) === null || _j === void 0 ? void 0 : _j.metadata) !== null && _k !== void 0 ? _k : {},
                                    currentSettings: (_l = prevState.generation) === null || _l === void 0 ? void 0 : _l.currentSettings,
                                    upcomingSettings: (_m = prevState.generation) === null || _m === void 0 ? void 0 : _m.upcomingSettings,
                                }, reactions: prevState.reactions
                                    ? __assign(__assign({}, prevState.reactions), { inProgress: [] }) : {
                                    disliked: [],
                                    pending: [],
                                    inProgress: [],
                                    totalDislikes: {},
                                }, caching: prevState.caching }];
                        return [4, extPersist.load(prevState)];
                    case 6: return [2, __assign.apply(void 0, _q.concat([(_r.sent())]))];
                    case 7:
                        e_1 = _r.sent();
                        logger.error("Unable to parse previous persisted state", {
                            err: e_1.toString(),
                        });
                        return [2, undefined];
                    case 8: return [2];
                }
            });
        });
    };
    return PersistenceService;
}());
exports.default = PersistenceService;
//# sourceMappingURL=index.js.map